






import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator';
import Query from './Query.vue'

const components = { Query }

@Component({ components })
export default class Queries extends Vue {
  @Prop() public values!: any[];

}
